import AppLayout from '@layouts/app-layout/app-layout';
export default AppLayout;
